import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WtStorageService } from './wt-storage.service';
import { AuthModule } from './modules/auth/auth.module';
import { CachingService } from './services/caching.service';
import { TokenInterceptorService } from './modules/auth/token-interceptor.service';
import { AdminModule } from './modules/admin/admin.module';
import { SideNavComponent } from './side-nav-menu/side-nav-menu.component';
import { NomenclatrueService } from './services/nomenclature.service';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { SuccessModalComponent } from './modals/success-modal/success-modal.component';
import { UnSuccessModalComponent } from './modals/failed-modal/failed-modal.component';
import { ServiceRequestComponent } from './components/service-request/service-request.component';
import { UploadComponent } from './modules/admin/documents/upload-component/upload.component';
import { ServiceRequestListComponent } from './components/service-request-list/service-request-list.component';
import { AllServiceRequestsComponent } from './components/all-service-requests/all-service-requests.component';
import { AllServiceRequestsService } from './services/all-service-requests.service';
import { KasaComponent } from './components/kasa/kasa.component';
import { KasaOpenComponent } from './components/kasa/kasa-open/kasa-open.component';
import { KasaCloseComponent } from './components/kasa/kasa-close/kasa-close.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { AccountComponent } from './components/header/account/account.component';
import { BookmarkComponent } from './components/header/bookmark/bookmark.component';
import { FeatherIconComponent } from './components/feather-icon/feather-icon.component';
import { LanguageComponent } from './components/header/language/language.component';
import { MaximiseComponent } from './components/header/maximise/maximise.component';
import { MessageBoxComponent } from './components/header/message-box/message-box.component';
import { ModeComponent } from './components/header/mode/mode.component';
import { NotificationComponent } from './components/header/notification/notification.component';
import { SearchComponent } from './components/header/search/search.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CreateTaxSettlementComponent } from './components/create-tax-settlement/create-tax-settlement.component';
import { TaxSettlementComponent } from './components/tax-settlement/tax-settlement.component';
import { SettlementdetailsComponent } from './components/tax-settlement/settlement-details/settlement-details.component';
import { BankAccountAddComponent } from './components/bank-account/bank-account-add/bank-account-add.component';
import { BankAccountComponent } from './components/bank-account/bank-account.component';
import { BankAccountEditComponent } from './components/bank-account/bank-account-edit/bank-account-edit.component';
import { BankSelectorComponent } from './shared/bank-selector/bank-selector.component';
import { EmailFilterComponent } from './components/mails/email-filter/email-filter.component';
import { MailInboxComponent } from './components/mails/mail-inbox/mail-inbox.component';
import { ReadMailComponent } from './components/mails/read-mail/read-mail.component';
import { ReadOutBoxComponent } from './components/mails/read-outbox/read-outbox.component';
import { ChangeClassificationModalComponent } from './components/mails/change-classification-modal/change-classification-modal.component';
import { FolderManagementModalComponent } from './components/mails/folder-management-modal/folder-management-modal.component';
import { MoveToFolderModalComponent } from './components/mails/move-to-folder-modal/move-to-folder-modal.component';
import { ComposeComponent } from './components/mails/compose/compose.component';
import { IssueManagerModule } from './modules/issue-Manager/issue-manager.module';
import { OrganizationTokenComponent } from './modules/admin/organization-token/organization-token.component';
import { OrgTokenCreationComponent } from './modules/admin/organization-token/org-token-creation/org-token-creation.component';
import { VikModule } from './modules/vik/vik.module';
import { EGovAutomationModule } from './modules/egov-automation/egov-automation.module';
import { Configuration } from './app-config';
import { MapsLoaderService } from './shared/services/maps-loader.service';
import { SharedModule } from './shared/shared.module';
import { registerLocaleData } from '@angular/common';
import localeBg from '@angular/common/locales/bg';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AddAnonaSignalRegistrationComponent } from './modules/vik/components/modals/anona-add-signal/anona-add-signal.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { EPayPaymentComponent } from './components/epay/epay-payment/epay-payment.component';
import { EpayService } from './services/epay.service';
import { EPayProfilePaymentComponent } from './components/epay/epay-profile/epayProfile-payment.component';
import { EPaySuccessComponent } from './components/epaysuccess/epaySuccess.component';
import { EPayFailComponent } from './components/epayfail/epayfail.component';
import { MPostPayComponent } from './components/mPost/mpost-pay.component';
import { AnonaHeaderComponent } from './components/header/anona-header/anona-header.component';
import { AnonaSignalComponent } from './components/anona-signal/anona-signal.component';


registerLocaleData(localeBg);


export function googleMapsLoader(mapsLoaderService: MapsLoaderService) {
  return () => {
      return new Promise<void>((resolve) => {
        mapsLoaderService.loadGoogleMapsAPIs().subscribe(() => {
          resolve();
        });
      });
  };
}


@NgModule({
  declarations: [
    AppComponent,
    //template
    AccountComponent,
    BookmarkComponent,
    LanguageComponent,
    MaximiseComponent,
    MessageBoxComponent,
    ModeComponent,
    NotificationComponent,
    SearchComponent,
    HeaderComponent,
    AnonaHeaderComponent,
    SidebarComponent,
    FooterComponent,
     //template
    SideNavComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    ConfirmModalComponent,
    SuccessModalComponent,
    UnSuccessModalComponent,
    ServiceRequestComponent,
    ServiceRequestListComponent,
    AllServiceRequestsComponent,
    KasaComponent,
    KasaOpenComponent,
    KasaCloseComponent,
    CreateTaxSettlementComponent,
    TaxSettlementComponent,
    SettlementdetailsComponent,
    BankAccountAddComponent,
    BankAccountEditComponent,
    BankAccountComponent,
    EmailFilterComponent,
    MailInboxComponent,
    ReadMailComponent,
    ReadOutBoxComponent,
    ChangeClassificationModalComponent,
    FolderManagementModalComponent,
    MoveToFolderModalComponent,
    ComposeComponent,
    OrganizationTokenComponent,
    OrgTokenCreationComponent,
    AddAnonaSignalRegistrationComponent,
    EPayPaymentComponent,
    EPayProfilePaymentComponent,
    EPaySuccessComponent,
    EPayFailComponent,
    MPostPayComponent,
    AnonaSignalComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    HttpClientJsonpModule,
    TranslateModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    AuthModule.forRoot(),
    NgApexchartsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AdminModule.forRoot(),
    VikModule.forRoot(),
    EGovAutomationModule,
    IssueManagerModule.forRoot(),
    NgbModule,
    SharedModule.forRoot(),
    NgxIntlTelInputModule,
    NgxDropzoneModule
  ],
  exports:[

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    WtStorageService,
    CachingService,
    NomenclatrueService,
    LayoutService,
    NavService,
    EpayService,
    AllServiceRequestsService,
    Configuration,
    {
      provide: APP_INITIALIZER,
      useFactory: googleMapsLoader,
      multi: true,
      deps: [MapsLoaderService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
